import * as Vue from 'vue'
import * as Vuex from 'vuex'

//时间生成
import mutations from './mutations'
import actions from './actions'
// import { store } from 'core-js/modules/_wks'

export default Vuex.createStore({
  state: {
    name: '',
    UserInfo: '',
    top: true,
    user: true,
    footer: true,
    banner: true,
    floatAd: true,
    fixedImg: true,
    fileLoading: true,
    progressNum: 0,
    Name: '',
    index: '1',
    size: '',
  },
  getters: {
    UserInfo(state) {
      return state.UserInfo
    },
  },
  mutations: {
    //修改state的方法
    updateLoading(state, type) {
      state.vueElementLoading = type
    },

    ...mutations,
    getIndex(state, index) {
      state.index = index
    },
    getSize(state, size) {
      state.size = size
    },
  },
  actions,
})
